import React from 'react';
import { LucideIcon } from 'lucide-react';

interface StatsCardProps {
  name: string;
  value: string | number;
  icon: LucideIcon;
}

export const StatsCard: React.FC<StatsCardProps> = ({ name, value, icon: Icon }) => {
  return (
    <div className="overflow-hidden rounded-lg bg-white p-4 shadow-sm ring-1 ring-gray-900/5 dark:bg-gray-800 dark:ring-gray-800">
      <div className="flex items-center gap-3">
        <div className="rounded-lg bg-[#0a8345]/10 p-2">
          <Icon className="h-5 w-5 text-[#0a8345]" />
        </div>
        <div>
          <p className="text-sm font-medium text-gray-500 dark:text-gray-400">
            {name}
          </p>
          <p className="text-xl font-semibold text-gray-900 dark:text-white">
            {value}
          </p>
        </div>
      </div>
    </div>
  );
};